import React from 'react'
import PropTypes from 'prop-types'
import ReactLoading from 'react-loading'

class Loading extends React.Component {
  constructor (...args) {
    super(...args)
    this.containerStyle = {
      position: 'absolute',
      width: '100%',
      textAlign: 'center',
      zIndex: 10,
      top: this.props.top
    }
  }

  render() {
    const { show, type, color, size } = this.props
    if (!show) return null
    return (
      <div style={this.containerStyle}>
        <div style={{ display: 'inline-block' }}>
          <ReactLoading type={type} color={color}  width={size} height={size}/>
        </div>
      </div>
    )
  }
}

Loading.defaultProps = {
  show: false,
  type: 'bubbles',
  color: 'red',
  size: '48px',
  top: 10
}

Loading.propTypes = {
  show: PropTypes.bool,
  size: PropTypes.string,
  color: PropTypes.string,
  top: PropTypes.number,
  type: PropTypes.oneOf(['blank', 'balls', 'bars', 'bubbles', 'cubes', 'cylon', 'spin', 'spinningBubbles', 'spokes'])
}

export default Loading



// WEBPACK FOOTER //
// ./src/components/widgets/Loading.js